<input #file type="file" style="display: none" (change)="onFilesAdded()" accept=".bex" filters=".bex" />

<div class="bmc-upload-bex bz-space--stack-l">
    <div class="bmc-upload-bex-header bz-space--stack-m">
        <span class="bmc-upload-bex-header__title">
            {{ 'DEPLOYMENT.NEED_A_PACKAGE' | translate }}
        </span>
        <div>
            <bzg-button-primary (click)="!isProcessing && uploadPackage()"
                [disabled]="showLoading || isProcessing || getCurrentStatus">
                {{'DEPLOYMENT.UPLOAD_NEW_PACKAGE' | translate}}
            </bzg-button-primary>
        </div>
    </div>
    <div *ngIf="!currentBex || showLoading || getCurrentStatus">
        <div class="bmc-upload-bex-empty bz-color-border--neutral-400 bz-color-bg--neutral-200 bmc-upload-bex-empty__container bz-space--inset-m"
            *ngIf="!showLoading && !getCurrentStatus">
            <bzg-icon class="bz-space--inline-m" [nameIcon]="'empty-file'" [size]="30"></bzg-icon>
            <div class="bmc-upload-bex-empty__description">
                <strong>{{ 'DEPLOYMENT.BIZAGI_PACKAGE' | translate }}</strong>
                <span class="bz-font-size--body-small">{{ 'DEPLOYMENT.NO_FILE_UPLOADED' | translate }}</span>
            </div>
        </div>
        <div class="bmc-upload-bex-loading bz-color-border--theme-400 bz-color-bg--neutral-200 bmc-upload-bex-empty__container bz-space--inset-m"
            *ngIf="showLoading || getCurrentStatus">
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="statusApply && statusApply === 'Begin'"><strong
                    class="bz-font-size--body-small">{{'DEPLOYMENT.IMPORTING_PACKAGE' | translate}}</strong>
            </bz-loading>
            <bz-loading [theme]="'Beryllium'" [size]="'l'"
                *ngIf="statusApply && statusApply === 'LoadingReasons'"><strong
                    class="bz-font-size--body-small">{{'DEPLOYMENT.VERIFYING_MAINTENANCE' | translate}}</strong>
            </bz-loading>
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="!statusApply && !getCurrentStatus"><strong
                    class="bz-font-size--body-small">{{'DEPLOYMENT.UPLOADING_PACKAGE' | translate}}</strong>
            </bz-loading>
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="getCurrentStatus"><strong
                    class="bz-font-size--body-small">{{'DEPLOYMENT.PREPARING_IMPORT' | translate}}</strong>
            </bz-loading>
        </div>
    </div>

    <div class="bmc-upload-bex-info bz-color-border--neutral-400 bz-color-bg--neutral-200"
        *ngIf="currentBex && !showLoading && !getCurrentStatus">
        <div class="bmc-upload-bex-info__container">
            <bzg-icon class="bz-space--inline-s bz-icon" [nameIcon]="'icon-done-file'" [size]="30"></bzg-icon>
            <div class="bmc-upload-bex-info-description">
                <strong>{{currentBex.BEX.Filename}}</strong>
                <bz-loading [size]="'s'" *ngIf="statusApply && statusApply === 'LoadingReasons'"></bz-loading>
                <div class="bmc-upload-bex-info-user__container bz-space--stack-xs">
                    <span class="bz-font-size--body-small">{{'DEPLOYMENT.UPLOADED_BY' | translate}}
                        {{currentBex.BEX.Username}} | {{currentBex.BEX.ImportTime | userTimezoneFormat: 1}}
                    </span>
                </div>
            </div>
            <div class="bmc-upload-bex-info-user">
                <button type="button" class="bz-space--inline-s bex-btn bex-btn--secondary bex-btn--s"
                    [disabled]="isProcessing" (click)="!isProcessing && openPackageVisualizer()">
                    {{ 'DEPLOYMENT.VIEW_CONTENT' | translate }}
                </button>
                <button *ngIf="enableViewDelta" type="button"
                    class="bz-space--inline-s bex-btn bex-btn--secondary bex-btn--s" [disabled]="isProcessing"
                    (click)="!isProcessing && openViewDelta()">
                    {{ 'DEPLOYMENT.COMPARE_WITH_TARGET' | translate }}
                </button>
                <button type="button" class="bz-space--inline-s bex-btn bex-btn--primary bex-btn--s"
                    [disabled]="isProcessing" (click)="!isProcessing && importPackage()">
                    {{ 'DEPLOYMENT.IMPORT' | translate }}
                </button>
                <button type="button"
                    class="bz-space--inline-s bex-btn bex-btn--secondary bex-btn--s bex-btn--icon bex-btn--border-neutral"
                    [disabled]="isProcessing" (click)="!isProcessing && cancel()"
                    [attr.aria-label]="'GLOBAL.CANCEL' | translate">
                    <svg width="14" height="14" viewBox="0 0 14 14" focusable="false" aria-hidden="true">
                        <path
                            d="M3.2 3.2c.26-.26.68-.26.94 0L7 6.06l2.86-2.86c.26-.26.68-.26.94 0s.26.68 0 .94L7.94 7l2.86 2.86c.26.26.26.68 0 .94s-.68.26-.94 0L7 7.94l-2.86 2.86c-.26.26-.68.26-.94 0s-.26-.68 0-.94L6.06 7 3.2 4.14c-.26-.26-.26-.68 0-.94Z"
                            fill="#9E9E9E" />
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <bzg-message *ngIf="(!statusApply || statusApply !== 'LoadingReasons') && (maintenanceReasons$ | async).length"
        class="bmc-upload-bex__validation-message" [status]="'warning'" [showCloseBtn]="false">
        <span class="bz-space--inline-l">{{ 'DEPLOYMENT.MAINTENANCE_WINDOW_GENERATE' | translate }}</span>
        <button type="button" class="bex-btn bex-btn--warning bex-btn--s"
            (click)="!showMaintenanceWindow()">
            {{ 'DEPLOYMENT.VIEW_DETAILS' | translate }}
        </button>
    </bzg-message>
</div>